
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../api/tmdbApi";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import * as Config from "../../constants/Config";
import Loader from "../../components/loader";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import TableLoader from "../../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

let { lambda, appname } = window.app

const StoreManage = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    //const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");

    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);

    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
const[image,setImg]=useState("")
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [locationData, setLocationData] = useState([]);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteLoad, setDeleteLoad] = useState(false);
    const [deleteItem, setDeleteItem] = useState(false);
    // const [sortDirection, setSortDirection] = useState('asc');
    const [toastMessage, setToastMessage] = useState("");
        const [toastType, setToastType] = useState("");// State for dynamic message
        const [deleteLoader,setDeleteLoader]=useState(false)




    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // // console.log('validate obj', validateObj)
    const userId = localStorage.getItem("userId");
    const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
    // // console.log('loginType',loginType,localStorage.getItem("clientid"));
    const useruniqueid = loginType === 'admin' ? localStorage.getItem("userId") : localStorage.getItem("clientid")
    const prevRoute = usePrevious(route)
    useEffect(() => {
        // console.log('prevRoute', prevRoute);
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
            // getStore()
        }

    }, [prevRoute]);

    useEffect(() => {
            if (toastMessage && toastType && toast[toastType]) {
                toast[toastType](toastMessage, {
                    position: "bottom-center",
                    // autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
    
                // Clear the message after showing to prevent re-triggering
                setToastMessage && setToastMessage("");
            }
        }, [toastMessage, toastType]);
        useEffect(() => {
 
            if (window.site === undefined) {
                setTimeout(() => {
                    if (window.site && window.site.common && window.site.common.imageCloudfront) {
                        setImg(window.site.common.imageCloudfront)
                    }
                }, 1000);
            }
            if (window.site && window.site.common && window.site.common.imageCloudfront) {
                setImg(window.site.common.imageCloudfront)
            }
        
        
        }, [window.site]);
    useEffect(() => {
        setIsLoading(true)
        getStore()
    }, []);
    
    //  // console.log('prevRoute--->',prevRoute)
    //  // console.log('currentRoute--->',route)
    const getStore = (e) => {
        // GetTimeActivity()
        const token = localStorage.getItem("token")
        // const userdata = localStorage.getItem("userdata")
        // console.log('userdata--->',userdata.username)
        // let userToken = userdata && userdata.token
        // console.log('userToken--->',userToken)
        axios({
            method: 'POST',
            url: `${lambda}/getStores?appname=${appname}&clientid=${useruniqueid}&token=${token}`,
            // + "&token=" + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    if (response?.data?.result.length > 0) {
                        const result = response?.data?.result;
                        setIsLoading(false)
                        setLocationData(result)
                        //  editUser?.companydetails?.[0].accountmanager
                    } else {
                        // setInvalidContent(true)
                        setIsLoading(false)
                        setLocationData(response?.data?.result)
                    }

                }

                // setDisableSaveBtn(false)
            });
    }

    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [

        {
            name: 'Name',
            selector: row => row?.name ?? "",
            sortable: true,
        },
        {
            name: 'User Type',
            selector: row => row?.type ?? "",
            sortable: true,
        },
        {
            name: 'Email id',
            selector: row => row?.emailid ?? "",
            sortable: true,
        },
        {
            name: 'Phone Number',
            selector: row => row?.phone ?? "",
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },


        {
            name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
            cell: (props) =>
                //   {
                subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
                <div className="d-flex">
                    {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
                        <a onClick={e => handleViewUser(e, props.userid)}
                            className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}><i
                                className="mdi mdi-eye font-size-18"></i></a>}
                    {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true && <>
                        {props.userid === id ? <a
                            className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
                                className="mdi mdi-pencil font-size-18"></i></a> : <a onClick={e => handleEditUser(e, props.userid)}
                                    className={`${subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === false ? 'pe-none' : ''} text-danger action-button`}><i
                                        className="mdi mdi-pencil font-size-18"></i></a>}</>}
                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };

    // console.log('datattatatattatat',data)
    useEffect(() => {
        setRoute("user")
        //  GetUserData();
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        //  // userActivity();
    }, []);
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    const GetUserData = async () => {
        GetTimeActivity()
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions

                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // console.log('objjjjjjjj--->',obj)
                // setActiveMenuObj(obj)

                // console.log('response?.result?.[0]', response?.result?.[0])
            }
        } catch {
            console.log("error");
        }
    };


    //  useEffect(() => {
    //      if (!localStorage.getItem("token")) {
    //          navigate("/");
    //      }

    //  }, []);

    //  useEffect(() => {


    //      console.log("trueeeeeeeeee",searchedFlag);
    //      if (searchedFlag) { 
    //          console.log("came") 
    //          handleSearch();
    //      } else {
    //          console.log("called get all deals") 
    //          User();
    //      }

    //  }, [searchedFlag]);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    const User = (e) => {
        GetTimeActivity()
        setIsLoading(true)
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/users?appname=' + appname + "&token=" + token,
        })
            .then(function (response) {
                // console.log("response", response);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setUser(response?.data?.result);
                    setData(response?.data?.result?.data);
                    global.exportExcelData = response?.data?.result?.data



                    setIsLoading(false);
                    setUserSearch("");
                    setSearchedFlag(false);
                }
            }).catch((err) => {
                // console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }





    const handleSearch = (e, flagggg) => {
        GetTimeActivity()
        if (flagggg) {
            setcurrentPage(1);
        }
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);
        if (flagggg === "normalsearch") {
            setSearchedFlag(true)
        }
        setFlag(true)
        if (usersearch === "") {
            User();
        }
        else {
            setIsLoading(true)
            const token = localStorage.getItem("token")
            axios({
                method: 'GET',
                url: lambda + '/users?appname=' + appname + "&search=" + usersearch + "&token=" + token,
            })
                .then(function (response) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        // console.log("response", response);
                        setUser(response?.data?.result);
                        setData(response?.data?.result?.data);
                        global.exportExcelData = response?.data?.result?.data



                        setIsLoading(false)
                    }
                }).catch((err) => {
                    // console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

    const handleChange = (e) => {
        if (e.target.value === "") {
            //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    //  const handleKeypress = (e) => {
    //      //it triggers by pressing the enter key
    //      GetTimeActivity()   
    //      if ((e.key === "Enter")) {
    //          setTimeout(function () {
    //              handleSearch();
    //          }, 1000);
    //      }
    //  };
    const handleAddUser = (e) => {
        GetTimeActivity()
        navigate("/adduser");
    }

    const handleEditUser = (e, paramuserid) => {
        // console.log('paramuserid', paramuserid)
        GetTimeActivity()
        navigate("/edituser/" + paramuserid);
    }
    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()
        // console.log('paramuserid', paramuserid)

        navigate("/viewuser/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        User();
        setcurrentPage(1);
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No users were found for the searched keyword</p>
                </div> </div>
        )
    }
    const handleExport = () => {

        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.name ?? "",
            "USER TYPE": each?.type ?? "",
            "EMAIL ID": typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "STATUS": each?.status ?? "",

        }));

        exportToExcel(modifiedArray, "data");

    }
    const handleAddStore = () => {
        navigate("/addstore")
    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `UsersData.xlsx`);
        // console.log('data22222--->', data)
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    // // console.log("showSessionPopupup",showSessionPopupup)
    const editclick = (item) => {
        navigate("/editstore/" + item?.storeid);
    }
    const deleteclick = (item) => {
        setShowDeleteAlert(true)
        setDeleteItem(item)
    }
    const handleClose = () => {
        setShowDeleteAlert(false)
    }
    

    const handleDeleteClick = async () => {
       // setDeleteLoad(true)
       setShowDeleteAlert(false)
        const token = localStorage.getItem('token');
        console.log("deleteItem",deleteItem)
        let storeid = deleteItem?.storeid
        try {
            const payload = {
                    "status": "ARCHIVE",
                
                };
            const response = await axios.post(
                `${lambda}/updateStore?appname=${appname}&clientid=${useruniqueid}&storeid=${storeid}`,payload
                
            );

            if (response.data.result) {
                getStore()
               // setDeleteLoad(false)
                       // setShowDeleteAlert(false)
                        setToastMessage("Location Deleted Successfully")
                        setToastType("success")
            }
        } catch (error) {
          console.error('Error deleting image:', error);
        }
    }

    let siteConfig = window?.site?.common;
    let appResourcesUrl = siteConfig?.imageCloudfront;
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}
              {isLoading?<Loader/>:   <div className="main-content user-management" id="user-management">
    <div className="page-content" id="page-content">
        <div className="container-fluid" id="container-fluid">
            <div className="row breadcrumb" id="breadcrumb">
                <div className="col-lg-12">
                    <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                            <h4 className="mb-2 card-title" id="page-title">Locations</h4>
                            <p className="menu-path" id="menu-path">
                                <span>Locations </span>
                            </p>
                        </div>
                        {userData?.usertype==="BRAND MANAGER" && <div>
                            <button 
                                className="fill-btn-style"
                                id="add-store-button"
                                onClick={handleAddStore}
                            >
                                ADD
                            </button>
                        </div>}
                        
                        {subValDashboard?.Add?.display === true && (
                            <div>
                                <button 
                                    className="fill-btn-style" 
                                    id="create-button"
                                    onClick={handleAddUser} 
                                    disabled={!subValDashboard?.Add?.enable}
                                >
                                    <span className="material-symbols-outlined">add_circle</span>
                                    Create
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="row table-data" id="table-data">
                <div className="col-12">
                    <div className="card" id="location-card">
                        <div className="card-body" id="location-card-body">
                            {locationData?.length > 0 ? (
                                <div className="row">
                                    {locationData.map((item, i) => {
                                        let image = item?.storeImages?.[0]?.filepath;
                                        let logo = item?.logo?.[0]?.filepath;
                                        let mergedImage = image 
                                            ? appResourcesUrl + image 
                                            : logo 
                                            ? appResourcesUrl + logo 
                                            : "assets/img/store-thumb-img.jpg";

                                        return (
                                            <div className="col-md-3 store_section" key={i} id={`store-section-${i}`}>
                                                <div className="store_block" id={`store-block-${i}`}>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <p className="store_id" id={`store-id-${i}`}>
                                                            Store ID: <span>{item?.storeid || ""}</span>
                                                        </p>
                                                        <div className="dropdown">
                                                            <span 
                                                                className="material-symbols-outlined dropdown-toggle" 
                                                                type="button" 
                                                                data-bs-toggle="dropdown" 
                                                                aria-expanded="false"
                                                                id={`dropdown-toggle-${i}`}
                                                            >
                                                                more_horiz
                                                            </span>
                                                            <ul className="dropdown-menu" id={`dropdown-menu-${i}`}>
                                                                <li>
                                                                    <a 
                                                                        className="dropdown-item active" 
                                                                        href="#" 
                                                                        id={`edit-store-${i}`} 
                                                                        onClick={(e) => editclick(item)}
                                                                    >
                                                                        <span className="material-symbols-outlined">edit</span>
                                                                        Edit
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a 
                                                                        className="dropdown-item" 
                                                                        href="#" 
                                                                        id={`delete-store-${i}`} 
                                                                        onClick={(e) => deleteclick(item)}
                                                                    >
                                                                        <span className="material-symbols-outlined">delete</span>
                                                                        Delete
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    {/* <div className="main_thumb">
                                                        <div className="img-dummy"></div>
                                                        <img 
                                                            src={mergedImage} 
                                                            className="asset-portrait-thumb" 
                                                            alt="default"
                                                            id={`store-image-${i}`}
                                                        />
                                                    </div> */}
                                                    <div className="main_thumb">
                                                        <div className="img-dummy">
                                                            <span className="location-active">Active</span>
                                                        </div>
                                                        <img
                                                            src={mergedImage}
                                                            className="asset-portrait-thumb"
                                                            alt="default"
                                                            id={`store-image-${i}`}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="thumb-content" id={`thumb-content-${i}`}>
                                                    <h3 id={`store-name-${i}`}>{item?.name || ""}</h3>
                                                    <p className="address" id={`store-address-${i}`}>{item?.address || ""}</p>
                                                    <p className="phone" id={`store-phone-${i}`}>
                                                        <span className="material-symbols-outlined">call</span>
                                                        {item?.phone || ""}
                                                    </p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="no-store" id="no-store">
                                    <img src={`${image}${appname}/images/web/Location-Default-Img.svg`} />
                                    <p>There are no locations available</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modal className="access-denied" show={showDeleteAlert} >

<div className="modal-body enquiry-form">
    <div className="container">
        <button className="close-btn" onClick={e => handleClose()}><span className="material-icons">close</span></button>
        {/* <span className="material-icons access-denied-icon">https</span> */}
        <span className="material-icons access-denied-icon">delete_outline</span>
        <h3>Delete</h3>
        <p>Are you sure you want to delete this location.</p>
        <div className="popup-footer">
            <button
                className="fill-btn mt-3"
                type="button"
                onClick={handleDeleteClick}

            >
                {deleteLoader ? (
                    <img
                        src={`${image}${appname}/images/web/rotate_right.svg`}
                        className="loading-icon"
                        alt="Loading"
                    />
                ) : null}
                Yes
            </button>


        </div>
    </div>
</div>

</Modal>
    <SweetAlert 
        show={tableErrMsg}
        custom
        confirmBtnText="ok"
        confirmBtnBsStyle="primary"
        title="Something went wrong. Please reload again."
        onConfirm={() => setTableErrMsg(false)}
        id="error-alert"
    />

    {/* <SweetAlert
        show={showDeleteAlert}
        title="Are you sure you want to delete this location?"
        showCancel
        confirmBtnText="OK"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        onConfirm={handleDeleteClick}
        onCancel={() => setShowDeleteAlert(false)}
        id="delete-alert"
    /> */}
    <ToastContainer
                            id="toastContainer"
                            position="bottom-center"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover={false}
                            theme="light"
                        />

    <Footer id="footer" />
</div>
}  

              


            </div>
        </>
    );
};

export default StoreManage;
